<template>
  <div
    class="o-grid__col u-6/12"
    v-model="active"
    :class="['c-tile-nav__column', item.order, {'c-tile-nav__column--active': isActive()}]"
  >
    <ul class="c-tile-nav__wrapper">
      <li>
        <a
          href="#"
          v-bind:class="[settings.class, settings.class + item.category, settings.class + item.position, {'c-tile-nav__tile--active': isActive()}]"
          @click.prevent="setActive"
          v-bind:data-modal="item.position"
          v-bind:data-modal-wrapper="item.color"
        >
          <span class="c-tile-nav__link-text">{{item.title}}</span>
          <img
            v-bind:src="settings.pageUrl + item.image"
            v-bind:class="'c-tile-nav__icon c-tile-nav__icon' + item.position"
          >
        </a>
        <ul class="c-tile-nav__wrapper-sub" v-if="hasChilds">
          <li
            is="nav-mechanism"
            v-for="(mechanism, mechanismIndex) in item['mechanisms']"
            :item="getChild(mechanism)"
            :index="mechanismIndex"
            :uid="mechanism"
            :parentModel="item"
          ></li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    settings() {
      return store.state.settings;
    },
    activeModel() {
      return store.state.runtime.activeItems["model"];
    }
  },
  methods: {
    setActive(event) {
      let uid = null;
      if (!this.isActive()) uid = this.uid;
      store.commit("unsetActiveItems");
      store.commit("setActiveItems", { type: "model", uid: uid });
      router.push({ path: "/" });
    },
    isActive() {
      return this.uid === this.activeModel;
    },
    hasChilds() {
      return this.item["mechanisms"].length > 0;
    },
    getChild(uid) {
      return store.state.data["mechanisms"][uid];
    }
  },
  model: {
    prop: "active",
    event: "change"
  },
  props: {
    // this allows using the `value` prop for a different purpose
    item: {
      type: Object
    },
    index: {
      type: Number
    },
    uid: {
      type: Number
    },
    // use `checked` as the prop which take the place of `value`
    active: {
      type: Boolean,
      default: false
    }
  }
};
</script>


// WEBPACK FOOTER //
// NavModel.vue?3cef1059